import { ReactNode } from 'react'
import { LazyMotion, domAnimation, motion } from 'motion/react'

interface AnimateEnterProps {
  children: ReactNode
  delay?: number
}

export function AnimateEnter({
  children,
  delay = 0,
}: Readonly<AnimateEnterProps>) {
  return (
    <LazyMotion features={domAnimation}>
      <motion.div
        initial={{ opacity: 0, y: 0 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ ease: 'easeIn', duration: 0.36, delay }}
      >
        {children}
      </motion.div>
    </LazyMotion>
  )
}
